import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import EnquiryForm from '../common/EnquiryForm';

const faqs = [
  {
    question: 'What is the eligibility for MBBS in India?',
    answer: 'Students must have completed 10+2 with Physics, Chemistry, Biology and English with minimum 50% marks (40% for reserved categories). They must qualify NEET-UG examination with minimum required percentile.',
  },
  {
    question: 'Is MBBS from abroad valid in India?',
    answer: 'Yes, MBBS from NMC/MCI approved foreign universities is valid in India. However, students must clear the FMGE/NExT screening test after completing their degree to practice in India.',
  },
  {
    question: 'What is the total cost of MBBS abroad?',
    answer: 'The cost varies by country. MBBS in Bangladesh costs around ₹25-35 lakhs total, Nepal ₹40-50 lakhs, Russia ₹20-30 lakhs, and Kazakhstan/Kyrgyzstan ₹15-20 lakhs including tuition, hostel, and living expenses.',
  },
  {
    question: 'Can I get education loan for MBBS?',
    answer: 'Yes, most nationalized and private banks offer education loans for MBBS both in India and abroad. We assist students in getting loans up to ₹50 lakhs with flexible repayment options.',
  },
  {
    question: 'What documents are required for MBBS admission abroad?',
    answer: 'Required documents include: 10th & 12th mark sheets, NEET scorecard, Passport, Birth certificate, Medical fitness certificate, Passport size photographs, and Migration certificate.',
  },
  {
    question: 'How does Learn Rabbit help in the admission process?',
    answer: 'We provide end-to-end assistance including college selection, application processing, document verification, visa assistance, travel arrangement, and post-admission support. Our success rate is 98%.',
  },
];

const FAQSection = () => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container maxWidth="xl">
        <Typography
          variant="h2"
          align="center"
          sx={{ mb: 6, fontSize: { xs: '1.8rem', md: '2.5rem' } }}
        >
          Frequently Asked{' '}
          <Box component="span" sx={{ color: 'secondary.main' }}>
            Questions
          </Box>
        </Typography>

        <Grid container spacing={4} alignItems="flex-start">
          <Grid item xs={12} md={7}>
            {faqs.map((faq, index) => (
              <Accordion
                key={index}
                expanded={expanded === `panel${index}`}
                onChange={handleChange(`panel${index}`)}
                sx={{ mb: 1, '&:before': { display: 'none' }, boxShadow: 1 }}
              >
                <AccordionSummary expandIcon={<ExpandMore />}>
                  <Typography variant="h6" sx={{ fontWeight: 500 }}>
                    {faq.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
                    {faq.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Grid>

          <Grid item xs={12} md={5}>
            <EnquiryForm />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default FAQSection;